import * as yup from 'yup';

export const createContentValidationSchema = (isLongContent: boolean) =>
  yup.object().shape({
    image: yup
      .mixed()
      .test('required', 'Image is required', (value) => 
        // Check if value exists (either string URL or File)
         !!(
          (typeof value === 'string' && value) ||
          value instanceof File
        )
      )
      .test('fileSize', 'File size exceeds 1MB', (value) => {
        // If no value, skip this test (will be caught by required test)
        if (!value) return true;
        // If it's a string URL, it's valid
        if (typeof value === 'string') return true;
        // If it's a File, check the size
        if (value instanceof File) {
          const maxSize = 1048576; // 1MB
          return value.size <= maxSize;
        }
        // If it's neither string nor File, it's invalid
        return false;
      }),
    title: yup.string().required('Title is required'),
    subTitle: isLongContent
      ? yup.string().required('Subtitle is required')
      : yup.string().notRequired(),
    body: yup.string().required('Body text is required'),
    buttonLabel: yup.string().required('Button label is required'),
    buttonLink: yup
      .string()
      .required('Button link is required')
      .url('Please enter a valid URL'),
  });
